import { PRODUCTIONS_AGGREGATIONS } from '../../constants/endpointConstants';
import { conditionallyRemoveViewByFilters } from '../common';
import { getProductions, getPerformances, getAggregations, getPerformanceCities } from './productionsApi';
import { fetchQuery } from './queryFetcher';
import { PAGINATION_LIMIT_1000 } from './constants';
import { getCity, getConstants, getCountry } from '../API';

export const fetchProductions = async (aggregationQuery, pagination = PAGINATION_LIMIT_1000) => {
  const query = { ...aggregationQuery };
  const validQuery = conditionallyRemoveViewByFilters(query);
  const queryKey = ['GET_PRODUCTIONS', JSON.stringify({ ...validQuery, pagination })];
  return fetchQuery(queryKey, () => getProductions(validQuery, pagination));
};

export const fetchPerformances = async (aggregationQuery, pagination = PAGINATION_LIMIT_1000) => {
  const validQuery = conditionallyRemoveViewByFilters(aggregationQuery);
  const queryKey = ['GET_PERFORMANCES', JSON.stringify({ ...validQuery, pagination })];
  return fetchQuery(queryKey, () => getPerformances(validQuery, pagination));
};

export const fetchSearchResults = async (aggregationQuery, pagination = PAGINATION_LIMIT_1000) => {
  const validQuery = conditionallyRemoveViewByFilters(aggregationQuery);
  const queryKey = ['GET_SEARCH_RESULTS', JSON.stringify({ ...validQuery, pagination })];
  return fetchQuery(queryKey, () => getAggregations(PRODUCTIONS_AGGREGATIONS, validQuery, pagination));
};

export const fetchCitiesWithPerformances = async (aggregationQuery, date, pagination = PAGINATION_LIMIT_1000) => {
  const query = { ...aggregationQuery, date_from: date, date_to: date };
  const validQuery = conditionallyRemoveViewByFilters(query);
  const queryKey = ['GET_CITY_PERFORMANCES', JSON.stringify({ ...validQuery, pagination })];
  return fetchQuery(queryKey, () => getPerformanceCities(PRODUCTIONS_AGGREGATIONS, validQuery, pagination));
};

export const fetchCountry = async countryId => {
  const queryKey = [`GET_COUNTRY_${countryId}`];
  return fetchQuery(queryKey, () => getCountry(countryId));
};

export const fetchCity = async cityId => {
  const queryKey = [`GET_CITY_${cityId}`];
  return fetchQuery(queryKey, () => getCity(cityId));
};

export const fetchAppConstants = async () => {
  const queryKey = ['GET_APP_CONSTANTS'];
  return fetchQuery(queryKey, () => getConstants());
};
